// src/components/CustomModal.tsx
// ✅ REFORMULADO: Modal institucional, sem emojis, profissional

import React, { useEffect, useRef } from 'react';
import './CustomModal.css';

interface CustomModalProps {
    isOpen: boolean;
    icon?: React.ReactNode;
    title: string;
    message: string;
    type?: 'success' | 'danger' | 'info';
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const CustomModal: React.FC<CustomModalProps> = ({
    isOpen,
    icon,
    title,
    message,
    type = 'info',
    confirmText = 'Confirmar',
    cancelText = 'Voltar',
    onConfirm,
    onCancel
}) => {
    const confirmButtonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (isOpen) {
            // Foco automático no botão de confirmar
            setTimeout(() => {
                confirmButtonRef.current?.focus();
            }, 100);

            // Fechar com ESC
            const handleEscape = (e: KeyboardEvent) => {
                if (e.key === 'Escape') {
                    onCancel();
                }
            };

            document.addEventListener('keydown', handleEscape);
            return () => document.removeEventListener('keydown', handleEscape);
        }
    }, [isOpen, onCancel]);

    if (!isOpen) return null;

    return (
        <div
            className="modal-overlay"
            onClick={onCancel}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
        >
            <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
                {icon && <div className="modal-icon">{icon}</div>}

                <h2 id="modal-title" className="modal-title">{title}</h2>
                <p className="modal-message">{message}</p>

                <div className="modal-actions">
                    <button
                        className="btn-modal-cancel"
                        onClick={onCancel}
                        type="button"
                    >
                        {cancelText}
                    </button>
                    <button
                        ref={confirmButtonRef}
                        className={`btn-modal-confirm ${type === 'danger' ? 'btn-modal-danger' : ''}`}
                        onClick={onConfirm}
                        type="button"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;